// Existing OpenAI measurement path, gated by Shopify processing permissions.
(function () {
  'use strict';
  var configNode = document.querySelector('[data-as-openai-config]');
  var config;
  try { config = configNode && JSON.parse(configNode.textContent); } catch (error) { return; }
  if (!config || config.enabled !== true || (window.Shopify && window.Shopify.designMode)) return;
  if (window.__ardanShieldOpenAIAdsTrackingStarted) return;
  window.__ardanShieldOpenAIAdsTrackingStarted = true;
  var pageContext = config;
  var pendingLeadKey = 'ardanshield:openai:pending-lead:v1';
  var leadLifetimeMs = 30 * 60 * 1000;
  var consentState = null;
  var privacyLoadRequested = false;
  var firedEvents = {};
  var recentEventWindowMs = 2000;
  var openAIAttributionSyncKey = null;
  var openAIAttributionPendingKey = null;
  var openAIAttributionPrivateAttributes = {
    oppref: '__openai_ads_oppref',
    obref: '__openai_ads_obref'
  };

  function initOpenAIAdsPixel() {
    if (window.__ardanShieldOpenAIAdsPixelInitialized) return;

    (function (w, d, s, u) {
      if (w.oaiq) return;
      var q = function () {
        q.q.push(arguments);
      };
      q.q = [];
      w.oaiq = q;
      var js = d.createElement(s);
      js.async = true;
      js.src = u;
      var f = d.getElementsByTagName(s)[0];
      f.parentNode.insertBefore(js, f);
    })(window, document, 'script', 'https://bzrcdn.openai.com/sdk/oaiq.min.js');

    window.oaiq('consent', true);
    window.oaiq('init', {
      pixelId: config.pixelId
    });
    window.__ardanShieldOpenAIAdsPixelInitialized = true;
  }

  function privacyReady() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
      typeof privacy.marketingAllowed === 'function');
  }

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        typeof privacy.marketingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true);
    } catch (error) { return false; }
  }

  function eventOptions(eventId) {
    var options = { opt_out: true };
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      options.opt_out = !privacy || typeof privacy.saleOfDataAllowed !== 'function' ||
        privacy.saleOfDataAllowed() !== true;
    } catch (error) { /* Keep personalization opted out when unknown. */ }
    if (eventId) options.event_id = eventId;
    return options;
  }

  function removePendingLead() {
    try { window.sessionStorage.removeItem(pendingLeadKey); } catch (error) { /* Measurement must not affect forms. */ }
  }

  function pendingLead() {
    try {
      var pending = JSON.parse(window.sessionStorage.getItem(pendingLeadKey) || 'null');
      if (!pending) return null;
      if (typeof pending.eventId !== 'string' || !/^lead:[a-z0-9-]+$/i.test(pending.eventId) ||
          typeof pending.formId !== 'string' || typeof pending.path !== 'string' ||
          !Number.isFinite(pending.at) || pending.at > Date.now() || Date.now() - pending.at > leadLifetimeMs) {
        removePendingLead();
        return null;
      }
      return pending;
    } catch (error) { return null; }
  }

  function rememberLeadSubmission(form) {
    try {
      if (!analyticsAllowed() || !form || !form.id || !form.querySelector) return;
      var type = form.querySelector('[name="form_type"]');
      if (!type || type.value !== 'contact' || form.querySelector('[data-openai-ads-lead-success]')) return;
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
      var crypto = window.crypto;
      if (!crypto || typeof crypto.randomUUID !== 'function') return;
      var previous = pendingLead();
      // Repeated submit/challenge events for one pending interaction keep one ID.
      var eventId = previous && previous.path === window.location.pathname && previous.formId === form.id
        ? previous.eventId : 'lead:' + crypto.randomUUID();
      window.sessionStorage.setItem(pendingLeadKey, JSON.stringify({
        eventId: eventId, path: window.location.pathname, formId: form.id, at: Date.now()
      }));
    } catch (error) { /* No storage or identifier support: omit measurement, never block submission. */ }
  }

  function readOpaqueCookie(name) {
    try {
      var cookiePrefix = name + '=';
      var cookies = document.cookie ? document.cookie.split('; ') : [];

      for (var index = 0; index < cookies.length; index += 1) {
        if (cookies[index].indexOf(cookiePrefix) === 0) {
          return cookies[index].slice(cookiePrefix.length);
        }
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function isSafeOpaqueAttributionValue(value) {
    return typeof value === 'string' &&
      value.length > 0 &&
      value.length <= 4096 &&
      !/[\u0000-\u001f\u007f]/.test(value);
  }

  function syncOpenAIAttributionToCart() {
    try {
      if (!analyticsAllowed() || !window.fetch) return;

      var oppref = readOpaqueCookie('__oppref');
      var obref = readOpaqueCookie('__obref');
      var attributes = {};

      if (isSafeOpaqueAttributionValue(oppref)) {
        attributes[openAIAttributionPrivateAttributes.oppref] = oppref;
      }
      if (isSafeOpaqueAttributionValue(obref)) {
        attributes[openAIAttributionPrivateAttributes.obref] = obref;
      }

      var attributeNames = Object.keys(attributes);
      if (!attributeNames.length) return;

      var syncKey = attributeNames.sort().map(function (name) {
        return name + ':' + attributes[name];
      }).join('|');
      if (syncKey === openAIAttributionSyncKey || syncKey === openAIAttributionPendingKey) return;
      openAIAttributionPendingKey = syncKey;

      window.fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: attributes
        })
      }).then(function (response) {
        // A failed cart update may retry on the next ordinary consent/checkout hook.
        // Do not mark it complete before Shopify accepts the update.
        if (response.ok) openAIAttributionSyncKey = syncKey;
        if (openAIAttributionPendingKey === syncKey) openAIAttributionPendingKey = null;
      }).catch(function () {
        if (openAIAttributionPendingKey === syncKey) openAIAttributionPendingKey = null;
      });
    } catch (error) {
      openAIAttributionPendingKey = null;
      return;
    }
  }

  function measureOpenAIAdsEvent(eventName, dedupeKey, duplicateWindowMs, eventId) {
    try {
      if (!analyticsAllowed() || !window.__ardanShieldOpenAIAdsPixelInitialized || typeof window.oaiq !== 'function') return false;
      var types = { page_viewed: 'contents', contents_viewed: 'contents', items_added: 'contents',
        checkout_started: 'contents', lead_created: 'customer_action' };
      if (!types[eventName]) return false;
      var key = dedupeKey || eventName;
      var now = Date.now();
      if (Object.prototype.hasOwnProperty.call(firedEvents, key) &&
          (duplicateWindowMs === undefined || now - firedEvents[key] < duplicateWindowMs)) return false;
      window.oaiq('measure', eventName, { type: types[eventName] }, eventOptions(eventId));
      firedEvents[key] = now;
      return true;
    } catch (error) { return false; }
  }

  function firePageLoadEvents() {
    measureOpenAIAdsEvent('page_viewed', 'page_viewed:' + window.location.pathname);

    if (pageContext.isProduct) {
      measureOpenAIAdsEvent('contents_viewed', 'contents_viewed:' + window.location.pathname);
    }
  }

  function fireContactFormSuccessEvents() {
    if (!analyticsAllowed()) return;
    var pending = pendingLead();
    if (!pending || pending.path !== window.location.pathname) return;
    var markers = document.querySelectorAll('[data-openai-ads-lead-success]');
    for (var index = 0; index < markers.length; index += 1) {
      var form = markers[index].closest('form');
      if (!form || form.id !== pending.formId) continue;
      // Only Shopify's success marker consumes the token. No form values are read.
      // A refresh/direct success URL without a pending submission cannot create a lead.
      if (measureOpenAIAdsEvent('lead_created', pending.eventId, undefined, pending.eventId)) removePendingLead();
      return;
    }
  }

  function closestElement(target, selector) {
    if (!target || target === document || !target.closest) return null;
    return target.closest(selector);
  }

  function checkoutFormCanSubmit(form) {
    var tosCheckbox = form ? form.querySelector('.tos_agree') : null;
    return !tosCheckbox || tosCheckbox.checked;
  }

  function isCheckoutPath(value) {
    return typeof value === 'string' && /\/checkout(?:[/?#]|$)/.test(value);
  }

  function isCheckoutTrigger(target) {
    var trigger = closestElement(target, [
      'a[href*="/checkout"]',
      'button[name="checkout"]',
      'input[name="checkout"]',
      'button[id="checkout"]',
      'input[id="checkout"]',
      '[data-cart-checkout-button]',
      '[data-minicart-checkout-button]',
      '[data-checkout-button]',
      '[data-cart-checkout]',
      '.cart__checkout',
      '.cart_checkout',
      '.checkout',
      '.js-checkout',
      '.shopify-payment-button button',
      '.shopify-payment-button__button'
    ].join(', '));

    if (!trigger) return null;

    var form = trigger.closest ? trigger.closest('form') : null;
    var href = trigger.getAttribute ? trigger.getAttribute('href') : '';
    var formAction = trigger.getAttribute ? trigger.getAttribute('formaction') : '';

    if (isCheckoutPath(href) || isCheckoutPath(formAction) || !form || checkoutFormCanSubmit(form)) {
      return trigger;
    }

    return null;
  }

  function formSubmitsToCheckout(form, submitter) {
    if (!form) return false;

    var action = form.getAttribute('action') || '';
    var submitterAction = submitter && submitter.getAttribute ? submitter.getAttribute('formaction') : '';
    var submitterName = submitter && submitter.getAttribute ? submitter.getAttribute('name') : '';

    if (!checkoutFormCanSubmit(form)) return false;
    if (submitter) {
      return isCheckoutPath(submitterAction) ||
        submitterName === 'checkout' ||
        Boolean(isCheckoutTrigger(submitter));
    }

    return isCheckoutPath(action) ||
      Boolean(form.querySelector('[name="checkout"], [data-cart-checkout-button], [data-minicart-checkout-button], [data-checkout-button], [data-cart-checkout]'));
  }

  function fireCheckoutStarted() {
    syncOpenAIAttributionToCart();
    measureOpenAIAdsEvent('checkout_started', 'checkout_started:cart-flow', 30000);
  }

  function setupCheckoutStartedTracking() {
    document.addEventListener('click', function (event) {
      if (!isCheckoutTrigger(event.target)) return;

      fireCheckoutStarted();
    }, true);

    document.addEventListener('submit', function (event) {
      if (!formSubmitsToCheckout(event.target, event.submitter)) return;

      fireCheckoutStarted();
    }, true);
  }

  function setupItemsAddedTracking() {
    function bindAjaxSuccess() {
      if (!window.jQuery || !window.jQuery(document).ajaxSuccess) return false;

      window.jQuery(document).ajaxSuccess(function (event, xhr, settings) {
        try {
          var requestUrl = settings && settings.url ? settings.url : '';
          var requestType = settings && settings.type ? settings.type.toLowerCase() : 'get';

          if (requestType !== 'post' || requestUrl.indexOf('/cart/add.js') === -1) return;

          measureOpenAIAdsEvent('items_added', 'items_added:' + requestUrl + ':' + (settings.data || ''), recentEventWindowMs);
        } catch (error) {
          return;
        }
      });

      return true;
    }

    if (bindAjaxSuccess()) return;

    window.addEventListener('load', bindAjaxSuccess);
  }

  function initWhenAllowed() {
    try {
      var allowed = analyticsAllowed();
      if (!allowed) {
        if (window.__ardanShieldOpenAIAdsPixelInitialized && typeof window.oaiq === 'function' && consentState !== false) {
          window.oaiq('consent', false);
        }
        // Preserve a consented submit token while the API loads on the next page.
        if (privacyReady() || consentState === true) removePendingLead();
        consentState = false;
        return;
      }
      var wasInitialized = window.__ardanShieldOpenAIAdsPixelInitialized;
      initOpenAIAdsPixel();
      if (wasInitialized && consentState !== true) window.oaiq('consent', true);
      consentState = true;
      syncOpenAIAttributionToCart();
      firePageLoadEvents();
      fireContactFormSuccessEvents();
    } catch (error) { /* Provider errors cannot affect shopping or enquiry submission. */ }
  }

  function loadPrivacyApi() {
    var shopify = window.Shopify;
    if (shopify && shopify.customerPrivacy) { initWhenAllowed(); return; }
    if (!privacyLoadRequested && shopify && typeof shopify.loadFeatures === 'function') {
      privacyLoadRequested = true;
      try {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
          if (!error) initWhenAllowed();
        });
      } catch (error) { /* Missing privacy API remains a denied measurement state. */ }
    }
  }

  function setupConsentAwareInit() {
    initWhenAllowed();
    loadPrivacyApi();
    document.addEventListener('visitorConsentCollected', initWhenAllowed);
    // Shopify's native challenge may cancel the first submit event. Recording intent
    // here is safe: a later server-rendered success marker is still required to emit.
    document.addEventListener('submit', function (event) { rememberLeadSubmission(event.target); }, true);
    setupCheckoutStartedTracking();
    setupItemsAddedTracking();
    window.addEventListener('load', loadPrivacyApi);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupConsentAwareInit);
  } else {
    setupConsentAwareInit();
  }
})();
